import React from "react";
/* eslint-disable */
import {
  Box, Card, Grid, CardContent, Divider, CardHeader,
  TableBody, TableCell, TableContainer, TableHead, TableRow, Table, TableFooter
} from '@material-ui/core';
import Chip from '@material-ui/core/Chip';


export default class ComponentToPrint extends React.Component {

  render() {
    const stockBalanceDetails = this.props.stockBalanceDetails || [];
    const data = this.props.searchData || {};

    const flatRows = [];
    stockBalanceDetails.forEach(product => {
      if (product.grnDetails && product.grnDetails.length > 0) {
        product.grnDetails.forEach(grn => {
          flatRows.push({
            productCategoryName: product.productCategoryName,
            productName: product.productName,
            measuringUnit: product.measuringUnit,
            grnNumber: grn.grnNumber,
            grnDate: grn.grnDate,
            qty: grn.qty,
            issuedQty: grn.issuedQty,
            refusedQuantity: grn.refusedQuantity,
            availableQty: grn.availableQty
          });
        });
      } else {
        flatRows.push({
          productCategoryName: product.productCategoryName,
          productName: product.productName,
          measuringUnit: product.measuringUnit,
          grnNumber: '',
          grnDate: '',
          qty: '',
          issuedQty: '',
          refusedQuantity: '',
          availableQty: ''
        });
      }
    });

    return (
      <div align='left'>
        <h3><center><u>Stock Balance Report</u></center></h3>
        {/* <div >&nbsp;</div>
        <Grid style={{ padding: '20px' }} container spacing={2}>
          <Grid item md={2} xs={2}><h4>Group:</h4></Grid>
          <Grid item md={10} xs={10}>{data.group}</Grid>
          <Grid item md={2} xs={2}><h4>Operation Entity:</h4></Grid>
          <Grid item md={10} xs={10}>{data.factory}</Grid>
          <Grid item md={2} xs={2}><h4>Product Category:</h4></Grid>
          <Grid item md={10} xs={10}>{data.productCategory}</Grid>
          <Grid item md={2} xs={2}><h4>Product:</h4></Grid>
          <Grid item md={10} xs={10}>{data.product}</Grid>
          <Grid item md={2} xs={2}><h4>Date:</h4></Grid>
          <Grid item md={10} xs={10}>{data.fromDate}</Grid>
        </Grid>
        <div>&nbsp;</div> */}
        <Box minWidth={1050}>
          <TableContainer style={{ marginLeft: '5px' }}>
            <Table aria-label="stock-balance-table">
              <TableHead>
                <TableRow>
                  <TableCell>Product Category</TableCell>
                  <TableCell>Product</TableCell>
                  <TableCell>Measuring Unit</TableCell>
                  <TableCell>GTN Number</TableCell>
                  <TableCell>GTN Date</TableCell>
                  <TableCell>Qty</TableCell>
                  <TableCell>Issued Qty</TableCell>
                  <TableCell>Damaged Qty</TableCell>
                  <TableCell>Available Qty</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {flatRows.map((row, idx) => (
                  <TableRow key={idx}>
                    <TableCell>{row.productCategoryName}</TableCell>
                    <TableCell>{row.productName}</TableCell>
                    <TableCell>{row.measuringUnit == 1 ? 'Unit' : row.measuringUnit == 2 ? 'Kg' : 'g'}</TableCell>
                    <TableCell>{row.grnNumber}</TableCell>
                    <TableCell>{row.grnDate ? new Date(row.grnDate).toLocaleDateString('en-US', { year: '2-digit', month: '2-digit', day: '2-digit' }) : ''}</TableCell>
                    <TableCell>{row.qty !== '' ? Number(row.qty).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ''}</TableCell>
                    <TableCell>{row.issuedQty !== '' ? Number(row.issuedQty).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ''}</TableCell>
                    <TableCell>{row.refusedQuantity !== '' ? Number(row.refusedQuantity).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ''}</TableCell>
                    <TableCell>{row.availableQty !== '' ? Number(row.availableQty).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ''}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </div>
    );
  }

}
